/**
 * The route table, assembled from feature route modules.
 *
 * This file may only import `routes` barrels — never a page component. That
 * constraint is the whole point: the project this one learned from grew a
 * 789-line App.tsx holding every lazy import and every <Route>, and by then it
 * was nobody's file to clean up.
 */
import type { RouteObject } from 'react-router';

import { authProtectedRoutes, authRoutes } from '@/features/auth/routes';
import { organizationRoutes } from '@/features/organization/routes';
import { employeesRoutes } from '@/features/employees/routes';
import { evaluationsRoutes } from '@/features/evaluations/routes';
import { homeRoutes } from '@/features/home';
import { iamRoutes } from '@/features/iam';
import { notificationsRoutes } from '@/features/notifications';
import { staffingRoutes } from '@/features/staffing';
import { AppShell } from '@/shared/layout/AppShell';
import { NotFound } from '@/shared/components/NotFound';
import { createElement } from 'react';

export const routes: RouteObject[] = [
  ...authRoutes,
  {
    element: createElement(AppShell),
    children: [
      ...homeRoutes,

      ...authProtectedRoutes,

      ...organizationRoutes,

      ...employeesRoutes,
      ...iamRoutes,

      ...evaluationsRoutes,
      ...notificationsRoutes,
      ...staffingRoutes,
    ],
  },
  { path: '*', element: createElement(NotFound) },
];
